<nav
  class="breadcrumb"
  [attr.aria-label]="'coremediaBreadcrumb.label' | translate"
>
  <claas-icon-button
    [icon]="backIcon"
    iconSize="small"
    [ariaLabel]="'coremediaBreadcrumb.back' | translate"
    (click)="goBack()"
  />
  <div #viewport class="breadcrumb-viewport" [class.collapsed]="collapsed()">
    <ol
      id="coremedia-breadcrumb-trail"
      class="breadcrumb-trail"
      [class.collapsed]="collapsed()"
    >
      @if (collapsed()) {
        <li class="expansion">
          <button
            type="button"
            class="expand-button"
            [attr.aria-label]="'coremediaBreadcrumb.expand' | translate"
            aria-expanded="false"
            aria-controls="coremedia-breadcrumb-trail"
            (click)="expand()"
          >
            <span class="expand-visual" aria-hidden="true">&hellip;</span>
          </button>
        </li>
      }
      @for (
        item of visibleItems();
        track item.route;
        let first = $first;
        let last = $last
      ) {
        <li class="breadcrumb-item" [class.current]="last">
          @if (!first || collapsed()) {
            <span class="separator" aria-hidden="true">|</span>
          }
          @if (last) {
            <span
              class="label"
              aria-current="page"
              [title]="
                item.route === '/' ? (item.label | translate) : item.label
              "
            >
              {{ item.route === "/" ? (item.label | translate) : item.label }}
            </span>
          } @else {
            <a
              #ancestorLink
              class="label"
              [routerLink]="item.route"
              [title]="
                item.route === '/' ? (item.label | translate) : item.label
              "
            >
              {{ item.route === "/" ? (item.label | translate) : item.label }}
            </a>
          }
        </li>
      }
    </ol>
  </div>
</nav>
